import { ActionReducer, Action } from '@ngrx/store';
import { D2dBookingInitState, IBooking } from '../models/d2d-booking.interface';

export const UPDATE_AVAILABLE_PRODUCTS = 'UPDATE_AVAILABLE_PRODUCTS';
export const REFRESH_D2D_BOOKING = 'REFRESH_D2D_BOOKING';
export const RESET_D2D_STATE = 'RESET_D2D_STATE';
export const UPDATE_BOOKING_COUNT = 'UPDATE_BOOKING_COUNT';
export const INCREMENT_BOOKING_COUNT = 'INCREMENT_BOOKING_COUNT';
export const SAVE_BOOKING_DETAILS = 'SAVE_BOOKING_DETAILS';
export const UPDATE_IN_BOUND_BOOKING_OBJECT = 'UPDATE_IN_BOUND_BOOKING_OBJECT';
export const UPDATE_OUT_BOUND_BOOKING_OBJECT = 'UPDATE_OUT_BOUND_BOOKING_OBJECT';
export const UPDATE_OUT_BOUND_ADDRESS = 'UPDATE_OUT_BOUND_ADDRESS';
export const UPDATE_IN_BOUND_ADDRESS = 'UPDATE_IN_BOUND_ADDRESS';
export const UPDATE_IS_BOOKING_COMPLETE = 'UPDATE_IS_BOOKING_COMPLETE';
export const UPDATE_ADD_BOOKING_COUNT = 'UPDATE_ADD_BOOKING_COUNT';
export const SAVE_FORM_DATA = 'SAVE_FORM_DATA';
export const SAVE_PROMO_CODE = 'SAVE_PROMO_CODE';
export const SAVE_OUT_BOUND_PRICE = 'SAVE_OUT_BOUND_PRICE';
export const SAVE_IN_BOUND_PRICE = 'SAVE_IN_BOUND_PRICE';
export const SELECTED_SERVICE_TYPE = 'SELECTED_SERVICE_TYPE';
export const UPDATE_SESSION_REQUEST = 'UPDATE_SESSION_REQUEST';
export const APPLE_PAY_TOKEN = 'APPLE_PAY_TOKEN';
export const GOOGLE_PAY_TOKEN = 'GOOGLE_PAY_TOKEN';
export const PAYPAL_PAY_TOKEN = 'PAYPAL_PAY_TOKEN';
export const PAYMENT_TYPE = 'PAYMENT_TYPE';
export const CAN_AVAIL_D2D = 'CAN_AVAIL_D2D';
export const PAYMENT_WITH_SAVED_CARD = 'PAYMENT_WITH_SAVED_CARD';
export const CARD_TYPE = 'CARD_TYPE';
export const PROMO_DETAILS = 'PROMO_DETAILS';
export const SESSION_SERVICE_TYPE = 'SESSION_SERVICE_TYPE';
export const SAVE_POST_OFFICE_PRICE = 'SAVE_POST_OFFICE_PRICE';
export const UPDATE_CURRENT_BOOKING_PRODUCT = 'UPDATE_CURRENT_BOOKING_PRODUCT';
export const UPDATE_ENTRY_SOURCE = 'UPDATE_ENTRY_SOURCE';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: D2dBookingInitState = {
  flightDetails: {
    flightProducts: {
      abc: false,
      ccd: false,
      sds: false,
      isDomesticABC: false
    }
  },
  bookingCount: 0,
  addBookingCount: 0,
  inboundBooking: {} as IBooking,
  outboundBooking: {} as IBooking,
  formData: null,
  promoCode: [],
  outboundPrice: '',
  inboundPrice: '',
  departurePostOfficePrice: '',
  userSelectedServicetype: '',
  hasSession: false,
  sessionFlightStatusRequest: {},
  paymentType: 2, // 0 = google Pay, 1 = Apple Pay, 2 = Card payment, 3 = PayPal
  applePayToken: null,
  googlePayToken: null,
  paypalPayToken: null,
  canAvailD2d: true,
  paymentWithSavedCard: false,
  cardType: '',
  promoDetails: null,
  sessionServiceType: '',
  currentBookingProduct: '',
  entrySource: 'direct',
};

export function d2dReducer(state: D2dBookingInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {

    case UPDATE_AVAILABLE_PRODUCTS:
      return Object.assign({}, state, { flightDetails: Object.assign({}, state.flightDetails, { flightProducts: action.payload }) });

    case UPDATE_BOOKING_COUNT:
      return Object.assign({}, state, { bookingCount: action.payload });

    case INCREMENT_BOOKING_COUNT:
      return Object.assign({}, state, { bookingCount: state.bookingCount + 1 });

    case UPDATE_ADD_BOOKING_COUNT:
      return Object.assign({}, state, { addBookingCount: action.payload });

    case SAVE_FORM_DATA:
      return Object.assign({}, state, { formData: action.payload });

    case SAVE_BOOKING_DETAILS:
      const { bookingType, ...bookingDetails } = action.payload;
      let updatedBookingObject;
      if (bookingType === 'inboundBooking') {
        updatedBookingObject = Object.assign({}, state, { inboundBooking: Object.assign({}, state.inboundBooking, bookingDetails) })
      } else {
        updatedBookingObject = Object.assign({}, state, { outboundBooking: Object.assign({}, state.outboundBooking, bookingDetails) });
      }
      const count = bookingCount(updatedBookingObject.inboundBooking, updatedBookingObject.outboundBooking);
      updatedBookingObject = Object.assign({}, updatedBookingObject, { bookingCount: count });
      return updatedBookingObject;

    case UPDATE_IN_BOUND_BOOKING_OBJECT:
      return Object.assign({}, state, { inboundBooking: Object.assign({}, state.inboundBooking, { currentBookingReducer: Object.assign({}, state.inboundBooking.currentBookingReducer, { currentBooking: action.payload }) }) });

    case UPDATE_OUT_BOUND_BOOKING_OBJECT:
      const b = Object.assign({}, state, { outboundBooking: Object.assign({}, state.outboundBooking, { currentBookingReducer: Object.assign({}, state.outboundBooking.currentBookingReducer, { currentBooking: action.payload }) }) });
      return b;
    case UPDATE_IN_BOUND_ADDRESS:
      return Object.assign({}, state, { inboundBooking: Object.assign({}, state.inboundBooking, { bookingReducer: Object.assign({}, state.inboundBooking.bookingReducer, { bookingDetails: Object.assign({}, state.inboundBooking.bookingReducer.bookingDetails, { customerAddress: action.payload }) }) }) });

    case UPDATE_OUT_BOUND_ADDRESS:
      return Object.assign({}, state, { outboundBooking: Object.assign({}, state.outboundBooking, { bookingReducer: Object.assign({}, state.outboundBooking.bookingReducer, { bookingDetails: Object.assign({}, state.outboundBooking.bookingReducer.bookingDetails, { customerAddress: action.payload }) }) }) });

    case UPDATE_IS_BOOKING_COMPLETE:
      const { _bookingType, isCompleted } = action.payload;
      let _updatedBookingObject;
      if (_bookingType === 'inboundBooking') {
        _updatedBookingObject = Object.assign({}, state, { inboundBooking: Object.assign({}, state.inboundBooking, { isCompleted: isCompleted }) });
      } else {
        _updatedBookingObject = Object.assign({}, state, { outboundBooking: Object.assign({}, state.outboundBooking, { isCompleted: isCompleted }) });
      }
      return _updatedBookingObject;

    case SAVE_PROMO_CODE:
      return Object.assign({}, state, { promoCode: action.payload });

    case SAVE_OUT_BOUND_PRICE:
      return Object.assign({}, state, { outboundPrice: action.payload });

    case SAVE_IN_BOUND_PRICE:
      return Object.assign({}, state, { inboundPrice: action.payload });

    case SELECTED_SERVICE_TYPE:
      return Object.assign({}, state, { userSelectedServicetype: action.payload });

    case SESSION_SERVICE_TYPE:
      return Object.assign({}, state, { sessionServiceType: action.payload });

    case UPDATE_ENTRY_SOURCE:
      return Object.assign({}, state, { entrySource: action.payload });

    case APPLE_PAY_TOKEN:
      return Object.assign({}, state, { applePayToken: action.payload });

    case GOOGLE_PAY_TOKEN:
      return Object.assign({}, state, { googlePayToken: action.payload });

    case PAYPAL_PAY_TOKEN:
      return Object.assign({}, state, { paypalPayToken: action.payload });

    case UPDATE_SESSION_REQUEST:
      return Object.assign({}, state, { hasSession: action.payload.hasSession, sessionFlightStatusRequest: action.payload.request});

    case CAN_AVAIL_D2D:
      return Object.assign({}, state, { canAvailD2d: action.payload });

    case PAYMENT_WITH_SAVED_CARD:
      return Object.assign({}, state, { paymentWithSavedCard: action.payload });

    case CARD_TYPE:
      return Object.assign({}, state, { cardType: action.payload });

    case PROMO_DETAILS:
      return Object.assign({}, state, { promoDetails: action.payload });

    case UPDATE_CURRENT_BOOKING_PRODUCT:
      return Object.assign({}, state, { currentBookingProduct: action.payload });

    case REFRESH_D2D_BOOKING:
      return Object.assign({}, action.payload);

    case RESET_D2D_STATE:
      return Object.assign({}, initState);

    case PAYMENT_TYPE:
      return Object.assign({}, state, { paymentType: action.payload});

    case SAVE_POST_OFFICE_PRICE:
      return Object.assign({}, state, { departurePostOfficePrice: action.payload });

    default:
      return state;

  }

};

function bookingCount(inbound, outbound): number {
  let count = 0;
  if (JSON.stringify(inbound) !== '{}') {
    count += 1;
  }
  if (JSON.stringify(outbound) !== '{}') {
    count += 1;
  }
  return count;
}
